import { useEffect, useState } from 'react';
import { useGLTF } from '@react-three/drei';
import  Setup  from '../Components/Setup.jsx';
import { Scene } from "../Scene.jsx";

export class LocationData {
	positionAnchorName;
	environmentModel;
	skyboxHeightOffset;
	azimuthAngle;
	overviewAzimuthAngle;
	overviewPolarAngle;

	constructor(positionName, environmentModel, skyboxHeightOffset, azimuthAngle, overviewAzimuthAngle, overviewPolarAngle) {
		this.positionAnchorName = positionName;
		this.environmentModel = environmentModel;
		this.skyboxHeightOffset = skyboxHeightOffset;
		this.azimuthAngle = azimuthAngle;
		this.overviewAzimuthAngle = overviewAzimuthAngle;
		this.overviewPolarAngle = overviewPolarAngle;
	}
}

export const LocationNames = {
	// Skybox to Cubemap: https://jaxry.github.io/panorama-to-cubemap/
	A: 'A', // Christoph's Skybox to Cubemap rotation: 149°
	B: 'B', // Christoph's Skybox to Cubemap rotation: 137°
}
LocationNames.ALL = Object.values(LocationNames);

export const Locations = {
	[LocationNames.A]: new LocationData(
		'Location_A',
		'./models/240215_Waldstaetter_Draco.glb',
		1.7, 70.0,
		300.0, 80.0
	),
	[LocationNames.B]: new LocationData(
		'Location_B',
		'./models/240215_Waldstaetter_Draco.glb',
		1.7, -125.0,
		120.0, 80.0
	),
};

export function Location({ location, setLocation, setPureVideo }) {

	const [gyroSettings, setGyroSettings] = useState({
		useGyro: false,
		permissionProcessed: false,
		initialSceneMedia: null 
	});

	return <>
		{gyroSettings.permissionProcessed
			? <Scene 
			gyroSettings={gyroSettings} 
			location={location} 
			setLocation={setLocation} 
			setPureVideo={setPureVideo} 
			initialSceneMedia={gyroSettings.initialSceneMedia} 
			/>
			: <Setup gyroSettings={gyroSettings} setGyroSettings={setGyroSettings} />}
	</>
}